import React, { Component } from 'react'
import { changePage, getUpSellItem, selectedFood, selectedNavComponent, setTotalOrderPrice, setHCommerceSavedOrders, setUpsellItem } from '../../../action/hcommerce'
import { closeOrderPopUp } from '../../action/hCommerce2'
import { popupOpenClose, setConformPage } from '../../../action/action'
import { connect } from 'react-redux'
import { CMSPath, HCOM_NEWER_FLOW_SIMILAR_TO_TV } from '../../../config/constant'
import { totalPriceCal } from '../../JS/totalPriceCal'
import { hCommColor } from '../../JS/colorConfig'
import { dynamicHeight } from '../../JS/listItemHeightFix';
import AddOnPopup from './addOnPopup/addOnPopup';
import $ from 'jquery';
import { scrollToTop } from '../../../JS/scrollToTop'
import { addToMyOrder, formatPriceForDisplay, removeUpsellItemUncheckingAtDetailScreen } from './itemActions';
import {withTranslation} from "react-i18next";
import { extractIdsOfStoreData, getCleanUrl, getDefaultAnalyticsLabel } from '../../JS/utility'
import { sendAnalytics } from '../../../action/homeAction'

class ItemInfo extends Component {
    constructor(props) {
        super(props)
        this.state = {
            addOn: [],
            quantity: 1,
            showAddOn:false,
            noSelection:false,
            upsellItemsList: [],
            addOnLength: 0,
            selectedUpsellItems:[]
            //upsell: []
        }
    }
    componentDidMount() {
        // setTimeout(() => {
        //     this.props.getUpSellItem(this.props.guestDetail, this.props.SelectedFood.id);
        // }, 1000)
        let count = 0
        for(let i=0;i<this.props.itemAddOnsInfo.length;i++){
            if(this.props.SelectedFood.id == this.props.itemAddOnsInfo[i].storeItemId) count++
        }
        this.setState({addOnLength: count })
        this.setState({upsellItemsList: extractIdsOfStoreData(this.props.SelectedFood.id, this.props.storeItemStoreUpsellItemInfo, 'storeUpsellItem', 'storeItem')})
        hCommColor(this.props.menuColor);
        dynamicHeight();
        scrollToTop();

        if(localStorage.getItem("storeInfoDetailEventSent") !== "true"){
            // Send Analytics
                let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
                this.props.sendAnalytics(
                    this.props.guestDetail, 
                    this.props.currentWidgets.widgetType, 
                    "STORE ITEM DETAIL", 
                    {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", "widgetSessionId": localStorage.getItem("hcommerceSessionToken"), pageName: "STORE INFO DETAIL", storeName: this.props.storeInfo.storeName}, 
                    0, 
                    this.props.guestIsLoggedIn,
                    () => localStorage.setItem("storeInfoDetailEventSent", true)
                );
            //
        }
    }

    goBack = () => {

        if(this.state.showAddOn){
            this.setState({showAddOn: false})
            return;
        }

        console.log('this.props.selectedNavComponent: ', this.props.SelectedNavComponent);
        if (this.props.SelectedNavComponent === 'StoreLevel1') {
            this.props.changePage("StoreLevel1");
        }
        else {
            this.props.changePage("StoreLevel2");
        }
    }

    quantityDecrease = () => {
        if (this.state.quantity > 1) {
            this.setState({ quantity: this.state.quantity - 1 });
        } else {
            this.props.popupOpenClose(true, "Can't decrease quantity more than 1.");
        }
    }

    quantityIncress = () => {
        this.setState({ quantity: this.state.quantity + 1 });
    }

    componentDidUpdate(prevProp,prevState) {
        // if (this.props.SelectedFood.id && preProp.SelectedFood.id !== this.props.SelectedFood.id) {
        //     this.props.getUpSellItem(this.props.guestDetail, this.props.SelectedFood.id);
        // }
        hCommColor(this.props.menuColor);
        dynamicHeight();

        if(this.state.showAddOn !== prevState.showAddOn){
            if(this.state.showAddOn){
                $("body").addClass("overlay-cast");
            }else{
                $("body").removeClass("overlay-cast");
            }
        }

        if(prevProp.SelectedFood != this.props.SelectedFood){

            let count = 0
            for(let i=0;i<this.props.itemAddOnsInfo.length;i++){
                if(this.props.SelectedFood.id == this.props.itemAddOnsInfo[i].storeItemId) count++
            }
            this.setState({addOnLength: count })
            this.setState({upsellItemsList: extractIdsOfStoreData(this.props.SelectedFood.id, this.props.storeItemStoreUpsellItemInfo, 'storeUpsellItem', 'storeItem')})
        }
       
    }

    clickRecommended = (selecteditem) => {
        $(".tile-sm.thumbnails.tile-container.upsell").addClass("scale-down-95");
        setTimeout(()=>{
            $(".tile-sm.thumbnails.tile-container.upsell").removeClass("scale-down-95");
        },100)

        setTimeout(()=>{
            this.props.selectedFood(selecteditem);
            window.scrollTo(0, 0);
            this.setState({
                addOn: [],
                quantity: 1
            })
        },200)
    }

    addOnCheckBoxCLick = (addOns, callback) => {
        this.setState({ addOn: addOns }, () => callback(true));
    }

    addToMyOrderCallback = () => {
        this.setState({showAddOn:false});
        this.setState({addOn:[]});
        this.goBack();
    }

    handleUpsellCheckBoxClicked = (item) => {
        console.log("inside handleUpsellCheckBoxClicked");

        let isItemAlreadyThere = this.state.selectedUpsellItems.some(item_ => item_.id == item.id ) ;

        if(!isItemAlreadyThere){
            // adding item with addon [] and quantity 1

            this.setState((prevState) => ({
                selectedUpsellItems: [...prevState.selectedUpsellItems, item]
              }));

            addToMyOrder(item, {quantity:1, addOn:[]}, this.props.setHCommerceSavedOrders,this.props.setTotalOrderPrice,this.props.closeOrderPopUp, ()=>{}, 'added to my cart');
        } else {
            // deleting quantity 1

            this.setState((prevState) => ({
                selectedUpsellItems: prevState.selectedUpsellItems.filter(item_=> item_.id!= item.id)
              }));

            removeUpsellItemUncheckingAtDetailScreen(item, this.props)
        }
    }

    componentWillUnmount(){
        $("body").removeClass("overlay-cast");
        // this.props.setUpsellItem([])
    }

    render() {
        const { t } = this.props
        // Milind: Fix: - 1. Images of upsell is wrong, not as defined in CMS. 2. Images of add on , not as defined in CMS
        let imagePathLarge = null;
        let selectedAddOn = false
        const add_to_cart = 'added to my cart'
        if (this.props.SelectedFood.storeItemImages.length === 1) {
            imagePathLarge = getCleanUrl(`${this.props.SelectedFood.storeItemImages[0].imagePath}`)
        } else {
            this.props.SelectedFood.storeItemImages.map((images) => {
                if (images.imageType === "LARGE") {
                    imagePathLarge = encodeURI(getCleanUrl(`${images.imagePath}`))
                }
            })
        }
        // if (this.props.SelectedFood.storeItemImages.length === 0) {
        //     imagePath = defaultImage
        // }
        return (
            <div>

                <header class="inner-pages subpages" style={{zIndex:"999"}}>
                    <a class="button-back" onClick={this.goBack}></a>
                    <div class="heading align-center">
                        <div class="splash-brand">
                            <img src={`${CMSPath}${this.props.logo}`} />
                        </div>
                    </div>
                </header>

                <section class="widgets detail-item">
                    <div class="widgets">
                        <div class="row">
                            <div class="row">
                                <div class="col col-2">
                                    <div class="details-header hcom"
                                        style={{
                                            background: `url(${imagePathLarge})`

                                        }}
                                    ></div>
                                    <div class="detail-body">
                                        <h4 style = {{alignItems:"flex-end"}}>
                                            <span class="item-name" style = {{width:"auto",padding:"0",flexGrow:"0"}} dangerouslySetInnerHTML={{__html: this.props.SelectedFood.itemName}}></span>
                                            <span class="item-price" style = {{padding:"0",marginLeft:"auto",display:"block",flexGrow:"0"}} dangerouslySetInnerHTML={{__html: `<span style ="font-size:1rem">${this.props.currencyCode}</span> ${formatPriceForDisplay(this.props.SelectedFood.itemPrice, this.props.precisionLength)}`}}></span>
                                        </h4>
                                        <div class="item-desc" dangerouslySetInnerHTML={{__html: this.props.SelectedFood.itemDescription}}>
                                            {/* {this.props.SelectedFood.itemDescription} */}
                                        </div>
                                        <div class="item-qty">
                                        { !this.props.storeInfo.disableAddRemoveItemsButtons && this.state.addOnLength == 0 ? 
                                            <>
                                                <div class="action-button">
                                                {this.state.quantity === 1 ? <a class="button" style={{opacity:0.5}}><i class="fas fa-lg fa-minus"></i></a> : <a class="button" onClick={this.quantityDecrease}><i class="fas fa-lg fa-minus"></i></a>}
                                                <input type="tel" name="qty" value={this.state.quantity} disabled/>
                                                <a class="button" onClick={this.quantityIncress}><i class="fas fa-lg fa-plus"></i></a>

                                                </div>
                                            </> 
                                        : null }
                                        </div>
                                        { !this.props.storeInfo.disableAddRemoveItemsButtons && <div class="item-add">
                                            <a class="button"
                                                onClick={() => {
                                                    this.state.addOnLength > 0 ? 
                                                    this.setState({showAddOn:true}) : addToMyOrder(this.props.SelectedFood,this.state,this.props.setHCommerceSavedOrders,this.props.setTotalOrderPrice,this.props.closeOrderPopUp,this.addToMyOrderCallback, `${add_to_cart}`)}}>{t('hcommerce.addon_popup.add_to_myorder')}</a>
                                        </div>}
                                        { this.props.storeInfo.disableAddRemoveItemsButtons && this.state.addOnLength > 0 && <div class="item-add">
                                            <a class="button secondary"
                                                onClick={() => this.setState({showAddOn:true})}>{"See options"}</a>
                                        </div>}
                                    </div>
                                </div>
                            </div>
                            
                            {/*this.props.SelectedFood.addOns && this.props.SelectedFood.addOns.length > 0 ?
                                <div class="row">

                                    <div class="addon-heading">This will go great with</div>

                                    <div class="col col-2 menu-items">
                                        {
                                            this.props.SelectedFood.addOns.map((iterator) => {
                                                let imagePathAddOns = null;

                                                imagePathAddOns = encodeURI(getCleanUrl(`${iterator.largeImage}`))

                                                return (
                                                    <a class="tile-sm thumbnails tile-container"
                                                        style={{
                                                            background: `url(${imagePathAddOns}) center center no-repeat`,
                                                            backgroundSize: "cover"
                                                        }}
                                                    >
                                                        <div class="thumb-text">
                                                            <p class="thumb-heading" style = {{height:"4rem"}}>{iterator.name}</p>

                                                            {
                                                                this.state.addOn.map(iter => {
                                                                    if (iter.id === iterator.id) {
                                                                        selectedAddOn = true
                                                                        return (
                                                                            <p class="addon-button">
                                                                                <span class="addon-price"
                                                                                style = {{flex:"1"}}>
                                                                                    Added
                                                                                </span>
                                                                                <span class="addon-icon"
                                                                                    style = {{flex:"0"}}
                                                                                    onClick={() => this.addOnCheckBoxCLick(iterator)}
                                                                                >
                                                                                    <i class="fas fa-plus"></i>
                                                                                </span>
                                                                            </p>
                                                                        )
                                                                    }
                                                                })
                                                            }
                                                            {
                                                                !selectedAddOn ?
                                                                    <p class="addon-button">
                                                                        <span class="addon-price" style = {{flex:"1"}}>
                                                                            {this.props.currencyCode} {iterator.price}
                                                                        </span>
                                                                        <span class="addon-icon"
                                                                            onClick={() => this.addOnCheckBoxCLick(iterator)}
                                                                            style = {{flex:"0"}}
                                                                        >
                                                                            <i class="fas fa-plus"></i>
                                                                        </span>
                                                                    </p> : selectedAddOn = false
                                                            }
                                                        </div>
                                                    </a>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                                : null*/}
                                {console.log("this.props.upsellItem",this.props.upsellItem)}
                                {this.props.upsellItem.length > 0 && this.props.upsellItem.some(iterator => this.state.upsellItemsList.includes(iterator.id)) ?
                                <div class="row">
                                    <div class="addon-heading">{t('hcommerce.storelevel1.our_recommendations')}</div>
                                    <div class="col col-2 menu-items">
                                        {
                                            this.props.upsellItem.map((iterator) => {

                                                let imagePathUpsell = null;

                                                iterator.storeItemImages.map((images) => {
                                                    if (images.imageType === "SMALL") {
                                                        imagePathUpsell = encodeURI(getCleanUrl(`${images.imagePath}`))
                                                    }
                                                })

                                                return this.state.upsellItemsList.includes(iterator.id) &&  (

                                                    ( HCOM_NEWER_FLOW_SIMILAR_TO_TV ? 
                                                     <div class="tile-sm thumbnails tile-container upsell" onClick={() => { this.clickRecommended(iterator) }}>
                                                            <input type="checkbox"
                                                            checked={this.state.selectedUpsellItems.some(item=>{ return item.id==iterator.id})}
                                                            onChange={(e)=>{ this.handleUpsellCheckBoxClicked(iterator)}}
                                                            onClick={(e)=>{e.stopPropagation()}} />
                                                            <div class="content">
                                                                <img src={imagePathUpsell}  />
                                                                <div class="thumb-text">
                                                                    <p class="thumb-heading" dangerouslySetInnerHTML={{__html: `${iterator.itemName}`}}></p>
                                                                    <p class="thumb-subheading" dangerouslySetInnerHTML={{__html: `+ <span style ="font-size:0.8rem">${this.props.currencyCode}</span> ${formatPriceForDisplay(iterator.itemPrice, this.props.precisionLength)}`}}></p>
                                                                    </div>
                                                            </div>
                                                       </div>
                                                     :
                                                        <div class="tile-sm thumbnails tile-container"
                                                        onClick={() => { this.clickRecommended(iterator) }}
            

                                                    >
                                                        <img src={imagePathUpsell}  />
                                                        <div class="thumb-text">
                                                            <p class="thumb-heading" dangerouslySetInnerHTML={{__html: `${iterator.itemName}`}}></p>
                                                            {/* <p>Some Description here</p> */}
                                                        </div>
                                                    </div>
                                                    )
                                                )
                                            })}
                                    </div>
                                </div>
                                : null}
                        </div>
                    </div>
                </section>
                {
                    this.state.showAddOn && <AddOnPopup pageName="STORE INFO DETAIL" selectedAddOn = {selectedAddOn} addOn = {this.state.addOn}
                    addOnCheckBoxCLick = {this.addOnCheckBoxCLick} 
                    addToMyOrder = {() => addToMyOrder(this.props.SelectedFood,this.state,this.props.setHCommerceSavedOrders,this.props.setTotalOrderPrice,this.props.closeOrderPopUp,this.addToMyOrderCallback, `${add_to_cart}`)} 
                    backBtn = {() => {this.setState({showAddOn:false})}}/>
                    
                }
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        guestDetail: state.store.home.guestDetails,
        SelectedFood: state.store.Hcommerce.SelectedFood,
        SelectedNavComponent: state.store.Hcommerce.SelectedNavComponent,
        upsellItem: state.store.Hcommerce.upsellItem,
        myOrders: state.store.Hcommerce.myOrders,
        menuColor: state.store.home.MenuColor,
        storeInfo: state.store.Hcommerce.storeInfo,
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        itemAddOnsInfo: state.store.Hcommerce.itemAddOnsInfo,
        storeItemStoreUpsellItemInfo: state.store.Hcommerce.storeItemStoreUpsellItemInfo,
        currencyCode: state.store.home.clientConfig.currencyDetails ?
            state.store.home.clientConfig.currencyDetails.code : "",
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentHomePage: state.store2.currentHomePage,
        currentWidgets: state.store.sideNavBar.currentWidget,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
          precisionLength: state.store.home.clientConfig.currencyDetails ?
        state.store.home.clientConfig.currencyDetails.precisionLength : "",
        totalPrice: state.store.Hcommerce.totalPrice,
    }
}

export default connect(
    mapStateToProps,
    {
        changePage,
        getUpSellItem,
        popupOpenClose,
        setConformPage,
        selectedFood,
        setTotalOrderPrice,
        closeOrderPopUp,
        setHCommerceSavedOrders,
        setUpsellItem,
        sendAnalytics
    }
)(withTranslation('translations')(ItemInfo));